import React from 'react'
import { jqueryProcess } from '../externals/common'
import Message from './Message'
import Business from './Business'
import InterViews from './Interviews'
import Numbers from './Numbers'
import Works from './Works'
import CareerPaths from './CareerPaths'
import Footer from './Footer'
import Environment from './Environment'
import Recruitments from './Recruitments'
import scrollReveal from 'scrollreveal'
import EmployeeInterview from '../Interview'
import EmployeeRecruit from '../Recruit'
import { timingFunctionCollapse, timingFunctionExpand, animateImgKeyframe1, animateImgKeyframe2, animateImgOptions, isMobile } from '../animations'

class IndexPage extends React.PureComponent {

  render() {
    const { sr, toInterview, toRecruit } = this.props

    return (
      <div style={this.props.style} id="contents">
        <header className="l-header home-header">
          <div className="header-bg" />
          <div className="header-wrap">
            <div className="header-logo">
              <h1>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 614 100"><title>株式会社ソルパック</title><path class="logo-path-text" fill="#000000" d="M378.2 80.2V68.1H334V17.2h-14.7v63zm123.7-63h-15.3l-33.5 62.9h14.4l7.1-13.4h39.2l7.1 13.4h14.4l-33.4-62.9zm-20.8 37.5l13.2-24.8 13.2 24.8h-26.4zm-184.7-30c-7.2-6.2-17.3-9.5-29.4-9.5-27.8 0-40.2 16.8-40.2 33.5 0 9.5 3.8 18 10.8 24 7.2 6.2 17.3 9.5 29.4 9.5 27.8 0 40.2-16.8 40.2-33.5 0-9.5-3.8-18-10.8-24zM267 70.1c-7.6 0-14.1-2.1-18.6-6.1-4.4-3.8-6.8-9.3-6.8-15.4 0-10.7 7.9-21.4 25.4-21.4 7.6 0 14.1 2.1 18.6 6.1 4.4 3.8 6.8 9.3 6.8 15.4.1 10.7-7.8 21.4-25.4 21.4zm124.6-52.9v62.9H405V58.7h32.2c11.4 0 20.8-9.3 20.8-20.8s-9.3-20.8-20.8-20.8h-45.6zM405 46.7V29.3h31.2c4.6 0 8.3 3.9 8.3 8.7s-3.7 8.7-8.3 8.7H405zm195.3 13.5c-3.9 5.7-11 9.9-22 9.9-7.6 0-14.1-2.1-18.6-6.1-4.4-3.8-6.8-9.3-6.8-15.4 0-10.7 7.9-21.4 25.4-21.4 7.6 0 14.1 2.1 18.6 6.1 1.3 1.1 2.4 2.4 3.4 3.8l13-6.1c-1.5-2.3-3.4-4.5-5.6-6.3-7.2-6.2-17.3-9.5-29.4-9.5-27.8 0-40.2 16.8-40.2 33.5 0 9.5 3.8 18 10.8 24 7.2 6.2 17.3 9.5 29.4 9.5 17.5 0 28.9-6.7 35-15.8l-13-6.2zM183 41.3c24.4 0 35.8 9 35.8 20.1S207.5 82.2 183 82.2c-14.4 0-27.7-3-37.8-9.3l8.1-10.2c6.5 3.7 17.9 7.4 29.3 7.4 17.4 0 20.8-3.3 20.8-7.4s-3.3-7.4-20.8-7.4c-24.2-.1-35.5-9-35.5-20.1 0-11.1 11.4-20.1 35.8-20.1 13.6 0 26.2 4.2 34.7 9.8l-8 10c-4.4-3.7-14.2-7.7-27-7.7-17.4 0-20.8 3.1-20.8 7s3.3 7 20.8 7h.4z"/><path fill="#0057b5" d="M84.3 52.2v17.4l-30.4 8.7L.6 63v30.5l22.9 6.5V87l30.4 8.6 53.3-15.2V45.6L46.3 28.3v13z"/><path fill="#2880ce" d="M107.2 15.2L53.9 0 .6 15.2V50l60.9 17.4V54.3l-38-10.8V26.1l30.4-8.7 53.3 15.2z"/></svg>
              </h1>
              <p>株式会社ソルパック　経験者採用ページ</p>
            </div>
            <div className="header-toggle">
              <div><span /><span /><span /></div>
            </div>
            <nav className="header-nav">
              <ul>
                <li><a className="header-nav-link" href="#message">メッセージ</a></li>
                <li><a className="header-nav-link" href="#interviews">インタビュー</a></li>
                <li><a className="header-nav-link" href="#numbers">数字で見る</a></li>
                <li><a className="header-nav-link" href="#recruitments">採用情報</a></li>
                <li><a className="header-nav-link" href="#careerpaths">社内環境</a></li>
                <li><a className="header-nav-link" href="#works">ソリューション</a></li>
                <li className="entry">
                  <a target="_blank" href="/contact/recruitment-form" rel="noopener noreferrer" className="header-nav-link">ENTRY</a>
                </li>
              </ul>
            </nav>
          </div>
        </header>
        <main className="l-main theme-single">
          <article className="l-article">
            <section id="mainvisual">
              <div className="visual_text">
                <div className="text_content">
                  <div className="item">
                    <div className="bg">
                      <p><span className="txt">社員の笑顔が</span></p>
                    </div>
                    <div className="line"></div>
                  </div>
                </div>
                <div className="text_content">
                  <div className="item">
                    <div className="bg">
                      <p><span className="txt">会社の財産です</span></p>
                    </div>
                    <div className="line"></div>
                  </div>
                </div>
                <div class="btn_content"> <a href="#recruitments">募集要項はこちら</a></div>
              </div>
              <div className="visual_image">
                <div className="visual_image_first"><img src="images/mainvisual/imgA.jpg" alt=""/><img src="images/mainvisual/imgB.jpg" alt=""/><img src="images/mainvisual/imgC.jpg" alt=""/></div>
                <div className="visual_image_second"><img src="images/mainvisual/imgA.jpg" alt=""/><img src="images/mainvisual/imgB.jpg" alt=""/><img src="images/mainvisual/imgC.jpg" alt=""/></div>
                <div className="visual_image_third"><img src="images/mainvisual/imgA.jpg" alt=""/><img src="images/mainvisual/imgB.jpg" alt=""/><img src="images/mainvisual/imgC.jpg" alt=""/></div>
              </div>
              <div className="visual_copy" />
              <div className="visual_scroll"><a className="scroll_btn" href="#message">
                <svg className="scroll_arrows scroll_arrows_pc">
                  <path className="a1" d="M0 0 L30 32 L60 0" />
                  <path className="a2" d="M0 20 L30 52 L60 20" />
                  <path className="a3" d="M0 40 L30 72 L60 40" />
                </svg>
                <svg className="scroll_arrows scroll_arrows_sp">
                  <path className="a1" d="M0 0 L20 20 L40 0" />
                  <path className="a2" d="M0 10 L20 30 L40 10" />
                  <path className="a3" d="M0 20 L20 40 L40 20" />
                </svg>
                <p className="scroll_txt">scroll</p></a>
              </div>
            </section>
            <Message />
            <Business />
            <InterViews toInterview={toInterview} />
            <Numbers sr={sr} />
            <Recruitments toRecruit={toRecruit} />
            <CareerPaths />
            <Environment />
            <Works />
          </article>
        </main>
        <Footer />
        <div className="topscroll"><a href="#root">
          <svg className="svgIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
            <path d="M48,2V48H2V2H48m2-2H0V50H50V0Z"></path>
            <path d="M36.76,24.22l-10-6.54v20H23.2V17.62l-10,6.6V20.38l11.7-8.1,11.82,8.1Z"></path>
          </svg></a></div>
      </div>
    )
  }
}

export default class Home extends React.PureComponent {

  state = {
    showInterview: false,
    interviewData: null,
    showRecruit: false,
    recruitData: null,
    showTopPage: false,
  }

  clientRect = {
    left: 0,
    top: 0,
    width: 0
  }

  dataId

  constructor() {
    super()
    this.messageRef = React.createRef()
    this.sr = scrollReveal({
      duration: 1000,
      distance: '100px',
      easing: 'cubic-bezier(0.000, 0.490, 0.580, 1.000)',
      scale: 0,
    })
    this.toInterview = this.toInterview.bind(this)
    this.toRecruit = this.toRecruit.bind(this)
    this.backToHomeFromInterview = this.backToHomeFromInterview.bind(this)
  }

  animateTitle = (elQuery) => {
    this.sr.reveal(elQuery, {
      distance: '50px',
      origin: 'top',
      delay: 300
    })
  }

  keepBodyStay = () => {
    if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
      let bodys = document.querySelector('#contents')
      bodys.style.display = 'none'
    }
  }

  releaseBody = (el) => {
    if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
      let bodys = document.querySelector('#contents')
      bodys.style.display = ''
      el.scrollIntoView()
    }
  }

  // animateText = () => {
  //   let options = {
  //     distance: '300px',
  //     duration: 600,
  //     easing: 'cubic-bezier(0.015, 0.015, 0.220, 0.985)'
  //   }
  //   this.sr.reveal('#mainvisual .visual_text .text_content .item .line', {
  //     origin: 'left',
  //     ...options
  //   }, 600)
  //   this.sr.reveal('#mainvisual .visual_text .text_content .item .bg', {
  //     ...options,
  //     origin: 'right',
  //     delay: 300,
  //   }, 400)
  //   this.sr.reveal('#mainvisual .visual_text .text_content .item .bg > p', {
  //     ...options,
  //     origin: 'left',
  //     distance: '100px',
  //     delay: 900,
  //   }, 400)
  // }

  hideLoadingView = () => {
    let loadingEl = document.querySelector('#loading-container')
    let visualText = document.querySelector('#mainvisual .visual_text')
    loadingEl.style.display = 'none'
    visualText.style.display = 'block'

    // this.animateText()
  }

  componentDidMount() {
    // ハッシュで直接下層へアクセス
    // インタビューは非対応
    if(window.location.hash) {
      var url_hash = window.location.hash
      var hash_string = url_hash.slice(1)
      var target_id = document.getElementById(hash_string)

      if(target_id && hash_string.match(/recruit/)) {
        this.hideHeader()
        setTimeout(() => {
          document.body.style.overflow = 'hidden'
          document.body.style.paddingRight = '17px'
          this.keepBodyStay()
          this.setState({
            showRecruit: true,
            recruitData: hash_string
          })
        }, 0)
      }
    }

    // jQuery
    jqueryProcess()

    // section animation
    this.sr.reveal(document.querySelector('#message > .section_title'), {
      origin: 'right',
    }, 100)
    this.sr.reveal(document.querySelector('#message > .section_contents'), {
      delay: 200,
      origin: 'bottom',
    }, 100)
    this.sr.reveal(document.querySelector('#business > .section_title'), {
      origin: 'left',
    })
    this.sr.reveal(document.querySelector('#business > .section_contents'), {
      delay: 200,
      origin: 'bottom',
    })
    this.sr.reveal(document.querySelector('#interviews'), {
      origin: 'bottom'
    })
    this.animateTitle('#interviews > .section_title')
    this.sr.reveal('#interviews > .section_contents li', {
      origin: 'bottom'
    }, 200)

    this.animateTitle('#numbers > .section_title')

    this.animateTitle('#works > .section_title')
    this.sr.reveal('#works .works_list > div', {
      origin: 'bottom'
    }, 400)

    this.animateTitle('#careerpaths > .section_title')
    this.sr.reveal('#careerpaths > .section_contents > .careerpaths_txt', {
      origin: 'bottom',
      delay: 300,
    })

    this.animateTitle('#numbers > .section_title')
    this.sr.reveal('#numbers > .section_contents > .numbers_contents > .numbers_item', {
      origin: 'bottom',
      delay: 200,
    })

    this.sr.reveal('#environment > .section_left', {
      origin: 'left',
      delay: 100,
    })
    this.sr.reveal('#environment > .section_right', {
      origin: 'right',
      delay: 100
    })

    this.animateTitle('#recruitments > .section_title')
    this.sr.reveal('#recruitments .job_list > .job_item', {
      origin: 'bottom'
    }, 300)

    setTimeout(this.hideLoadingView, 3500)
    setTimeout(() => {
      this.setState({
        showTopPage: true
      })
    }, 0)
  }

  toInterview = (evt) => {
    this.hideHeader()

    let el = evt.currentTarget.querySelector('img')
    let visualEl = el.parentElement

    // don't animate photos if accessed via mobile
    if (!isMobile()) visualEl.style.visibility = 'hidden'

    this.dataId = visualEl.parentElement.getAttribute('data-id')
    let src = el.getAttribute('src')
    let elRect = el.getBoundingClientRect()
    let imgTransitionContainer = document.querySelector('#fake-img')
    let imgTransition = imgTransitionContainer.firstChild
    imgTransition.setAttribute('src', src)
    imgTransitionContainer.style.left = elRect.left + 'px'
    imgTransitionContainer.style.top = (document.documentElement.scrollTop + elRect.top) + 'px'
    elRect = el.getBoundingClientRect()

    let animateImg = () => {
      imgTransitionContainer.style.visibility = 'visible'
      elRect = el.getBoundingClientRect()
      let interviewImg = document.querySelector('.interview-img')
      interviewImg.style.visibility = 'hidden'
      interviewImg.firstChild.setAttribute('src', src)
      let lastRect = interviewImg.getBoundingClientRect()
      // store the img rect value from interview screen, to be used in reverse animation
      const { left, top, width, height } = lastRect
      this.clientRect = {
        left: left, //- window.screen.width + 667, // magic number
        top: top - 2900, //-> use this for slide from below
        width,
        height
      }
      imgTransitionContainer.animate([
        {
          transform: animateImgKeyframe2
        },
        {
          transform: animateImgKeyframe1(elRect, this.clientRect)
        },
      ], { ...animateImgOptions, delay: 100 })

      setTimeout(() => {
        interviewImg.style.visibility = 'visible'
        imgTransitionContainer.style.visibility = 'hidden'
        visualEl.style.visibility = 'visible'
      }, 1000)
    }

    setTimeout(() => {
      document.body.style.paddingRight = '17px'
      document.body.style.overflow = 'hidden'
      this.setState({
        showInterview: true,
        interviewData: this.dataId
      }, () => {
        // don't animate photos if accessed via mobile
        if (isMobile()) {
          let interviewImg = document.querySelector('.interview-img')
          interviewImg.style.visibility = 'visible'
          interviewImg.firstChild.setAttribute('src', src)
          this.keepBodyStay()
          let fixEle = document.querySelector('.interviews_lower')
          fixEle.style.paddingRight = '0px'
        } else animateImg()
      })
    }, 450)
  }

  hideHeader = () => {
    let header = document.querySelector('.home-header')
    let timeScale = 0.5
    let flip = new window.FLIP({
      element: header,
      duration: 400 / timeScale,
      easing: timingFunctionCollapse,
    })
    flip.first()
    flip.last('last')
    flip.invert()
    flip.play()

    // also hide scroll to top button
    let topscroll = document.querySelector('.topscroll')
    topscroll.style.display = 'none'
  }

  showHeader = () => {
    let header = document.querySelector('.home-header')
    let timeScale = 0.5
    let flip = new window.FLIP({
      element: header,
      duration: 500 / timeScale,
      easing: timingFunctionExpand,
    })
    flip.first()
    flip.removeClass('last')
    flip.last()
    flip.invert()
    flip.play()

    // also show scroll to top button
    let topscroll = document.querySelector('.topscroll')
    topscroll.style.display = 'block'
  }

  backToHomeFromInterview = () => {
    let el = document.querySelector("#interviews")
    this.releaseBody(el)
    setTimeout(() => {
      this.setState({
        showInterview: false
      })
      document.body.style.overflow = 'auto'
      document.body.style.paddingRight = 0
      this.showHeader()
      el.style.visibility = 'visible'
    }, 300)
  }

  backToHomeFromRecruit = () => {
    let el = document.querySelector("#recruitments")
    this.releaseBody(el)
    setTimeout(() => {
      this.setState({
        showRecruit: false
      })
      document.body.style.overflow = 'auto'
      document.body.style.paddingRight = 0
      this.showHeader()
    }, 300)
  }

  toRecruit(evt) {
    let dataId = evt.target.getAttribute('data-id')

    this.hideHeader()

    setTimeout(() => {
      document.body.style.overflow = 'hidden'
      document.body.style.paddingRight = '17px'
      this.keepBodyStay()
      this.setState({
        showRecruit: true,
        recruitData: dataId
      })
    }, 400)
  }

  fixedStyle = {
    overflow: 'auto',
    position: 'fixed',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    zIndex: '99',
    WebkitOverflowScrolling: 'touch'
  }

  render() {

    const {showRecruit, showInterview, interviewData, recruitData, showTopPage} = this.state

    return (
      <React.Fragment>
        <IndexPage
          messageRef={this.messageRef}
          sr={this.sr}
          toInterview={this.toInterview}
          toRecruit={this.toRecruit}
          style={{
            visibility: (showTopPage) ? 'visible' : 'hidden'
          }}
        />
        {showInterview &&
          <EmployeeInterview
            ref={this.interviewRef}
            backToHome={this.backToHomeFromInterview}
            sr={this.sr}
            style={this.fixedStyle}
            interviewData={interviewData}
          />
        }
        {showRecruit &&
          <EmployeeRecruit
            backToHome={this.backToHomeFromRecruit}
            data={recruitData}
            style={this.fixedStyle} />
        }
        <div id="fake-img" style={{
          position: 'absolute',
          width: '300px',
          height: '400px',
          top: '2790px',
          visibility: 'hidden',
          zIndex: 999,
        }}>
          <img src="" style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: '50% 0%'
          }} alt=""/>
        </div>
      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/Home/index.js